import { render, staticRenderFns } from "./addticket.vue?vue&type=template&id=700894d5&scoped=true&"
import script from "./addticket.vue?vue&type=script&lang=js&"
export * from "./addticket.vue?vue&type=script&lang=js&"
import style0 from "./addticket.vue?vue&type=style&index=0&id=700894d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700894d5",
  null
  
)

export default component.exports